import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './index.css';
import { PageView } from './components/PageView';
import { AdminPage } from './pages/AdminPage';
import { LoginPage } from './pages/LoginPage';
import { InstallPage } from './pages/InstallPage';
import SupportChat from './components/SupportChat';
import { ADMIN_PATH, LOGIN_PATH, api } from './lib/api';

/** 智能客服浮窗：仅公开页面显示（后台/安装/登录页不显示） */
function SupportChatGate() {
  const { pathname } = useLocation();
  if (pathname.startsWith(ADMIN_PATH) || pathname.startsWith('/install') || pathname.startsWith(LOGIN_PATH)) return null;
  return <SupportChat />;
}

function App() {
  const [status, setStatus] = useState<'loading' | 'yes' | 'no'>('loading');
  useEffect(() => {
    fetch(api('/api/install/status'))
      .then(r => r.json())
      .then(d => setStatus(d.installed ? 'yes' : 'no'))
      .catch(() => setStatus('yes'));
  }, []);

  if (status === 'loading') return <div className="min-h-screen bg-[#0a0a0f]" />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/install" element={<InstallPage />} />
        {status === 'no' && <Route path="/*" element={<Navigate to="/install" replace />} />}
        {/* 公开页全部由页面设计器数据驱动（blocks 渲染，后台可视化编辑即时生效） */}
        <Route path="/" element={<PageView slug="home" />} />
        <Route path="/models" element={<PageView slug="models" />} />
        <Route path="/pricing" element={<PageView slug="pricing" />} />
        <Route path="/p/:slug" element={<PageView />} />
        <Route path="/:slug" element={<PageView />} />
        <Route path={ADMIN_PATH} element={<AdminPage />} />
        <Route path={LOGIN_PATH} element={<LoginPage />} />
      </Routes>
      <SupportChatGate />
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);